<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <v-card outlined>
          <v-container fluid>
            <v-card max-width="1000px" outlined>
              <v-tabs fixed-tabs v-model="tab">
                <v-tab class="ml-0" :disabled="isDisabledTabItems">{{ $t('ELE0086') }}</v-tab>
                <v-tab :disabled="isDisabledTabItems">{{ $t('ELE0015') }}</v-tab>
                <v-tab-item>
                  <validation-observer v-slot="{ invalid }">
                    <v-row dense>
                      <v-col cols="4">
                        <FileInput
                          :label="$t('ELE0208')"
                          v-model="files"
                          accept=".csv"
                          rules="ext:csv"
                          :disabled="isDisabledTabItems"
                          multiple
                          required
                        />
                      </v-col>
                      <v-col cols="3" class="pt-2">
                        <BtnImport
                          v-if="csvType == enumImportInspCharMode.CAD"
                          @click="onClickImportCAD"
                          :disabled="isDisabledTabItems ? true : invalid"
                        />
                        <BtnImport v-else @click="onClickImportSPARQ" :disabled="isDisabledTabItems ? true : invalid" />
                      </v-col>
                      <v-col class="pt-2">
                        <BtnReset @click="onClickReset" :disabled="!isDisabledTabItems" />
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>
                        <v-radio-group v-model="csvType" class="mt-1" row :disabled="isDisabledTabItems">
                          <v-radio :label="$t('ELE0087')" :value="enumImportInspCharMode.CAD" />
                          <v-radio :label="$t('ELE0088')" :value="enumImportInspCharMode.SPARQ" />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </validation-observer>
                </v-tab-item>
                <v-tab-item class="pb-2 pl-2">
                  <validation-observer v-slot="{ invalid }">
                    <v-row dense>
                      <v-col cols="6" class="mt-1">
                        <PartCodeInput
                          :label="$t('ELE0031')"
                          v-model="searchPartCd"
                          required
                          :disabled="isDisabledTabItems"
                        />
                      </v-col>
                      <v-col>
                        <BtnSearch class="mx-2 mt-2" @click="onClickSearch" :disabled="isDisabledTabItems || invalid" />
                      </v-col>
                      <v-col class="mt-2">
                        <BtnReset @click="onClickReset" :disabled="!isDisabledTabItems" />
                      </v-col>
                    </v-row>
                  </validation-observer>
                </v-tab-item>
              </v-tabs>
            </v-card>
            <v-card outlined>
              <v-tabs v-model="tableTab" left width="125px" :show-arrows="false">
                <v-tab v-for="item in importItems" :key="item.index" :style="getTabColor(item)">
                  <v-progress-circular indeterminate v-if="item.isProcessing" />
                  <div v-else>{{ item.tabTitle }}</div>
                </v-tab>
                <v-tab-item v-for="item in importItems" :key="item.index" eager>
                  <InspCharacTable
                    ref="characTable"
                    :file="item.file"
                    :tabTitle.sync="item.tabTitle"
                    :isProcessing.sync="item.isProcessing"
                    :searchPartCd="item.searchPartCd"
                    :csvType="csvType"
                    :inspCharacTab="tab"
                    :saveStatus.sync="item.saveStatus"
                    :inspStd="inspStd"
                    :qltyStd="qltyStd"
                    :tecNoLimit="tecNoLimit"
                    :tecNoReq="tecNoReq"
                    :ptCdLen="ptCdLen"
                    @finishedSave="onFinishedSave(item)"
                    @deleteTab="onDeleteTab(item)"
                  />
                </v-tab-item>
              </v-tabs>
              <v-divider />
              <v-row>
                <v-col class="d-flex justify-end">
                  <BtnSave v-if="importItems.length" @click="onClickSave" />
                </v-col>
              </v-row>
            </v-card>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { API } from '@/plugins/api'

import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtils from '@/mixin/date-utils'
import StringUtils from '@/mixin/string-utils'
import { MeasFmtCd, SystemParameterKey } from '@/enum'

import { ValidationObserver } from 'vee-validate'
import FileInput from '@/components/atoms/base/file/FileInput'
import Btn from '@/components/atoms/base/button/Btn.vue'
import BtnSearch from '@/components/atoms/button/BtnSearch'
import PartCodeInput from '@/components/atoms/select/PartCodeInput'
import BtnSave from '@/components/atoms/button/BtnSave'
import BtnReset from '@/components/atoms/button/BtnReset'
import BtnImport from '@/components/atoms/button/BtnImport'
import InspCharacTable from '@/components/organisms/master/form/InspCharacTable'

const MAX_FILE_IMPORT_COUNT = 10

/** 特性マスタ取込 CSV取込モード **/
const ImportInspCharMode = {
  CAD: '1',
  SPARQ: '2',
}
/** 特性マスタ取込 タブ **/
const InspCharacTabs = {
  IMPORT: '0',
  SEARCH: '1',
}
/** 処理用 **/
const SaveStatus = {
  WAITING: '0',
  SAVING: '1',
  SUCCESS: '2',
  ERROR: '3',
}

export default {
  name: 'InspCharacForm',

  mixins: [APIUtils, Message, Loading, DateUtils, StringUtils],

  components: {
    ValidationObserver,
    FileInput,
    Btn,
    BtnSearch,
    PartCodeInput,
    BtnSave,
    BtnReset,
    BtnImport,
    InspCharacTable,
  },

  data() {
    return {
      isDisabledTabItems: false,
      searchPartCd: '',
      item: null,
      csvType: '1',
      revValue: '',
      tab: 0,
      tableTab: 0,
      files: [],
      importItems: [],
      inspStd: [],
      qltyStd: [],
      tecNoLimit: 200,
      tecNoReq: false,
      ptCdLen: '',
    }
  },

  computed: {
    enumImportInspCharMode: () => ImportInspCharMode,
    emumMeasFmtCd: () => MeasFmtCd,
    enumInspCharacTabs: () => InspCharacTabs,
  },

  methods: {
    getTabColor(item) {
      let result = ''
      if (item.saveStatus == SaveStatus.ERROR) {
        result = 'color: #ffffff !important; background-color: #F44336 !important'
      }
      return result
    },
    onClickReset() {
      this.files = []
      this.importItems = []
      this.isDisabledTabItems = false
    },
    onClickImportCAD() {
      if (this.files.length > MAX_FILE_IMPORT_COUNT) {
        this.setErrorMessage(this.$t('MSG0144', { p0: MAX_FILE_IMPORT_COUNT }))
        return
      }
      this.isDisabledTabItems = true
      this.items = []
      this.files.forEach((element, index) => {
        this.importItems.push({
          file: element,
          tabTitle: '',
          index: index,
          isProcessing: true,
          saveStatus: SaveStatus.WAITING,
        })
      })
    },
    onClickImportSPARQ() {
      if (this.files.length > MAX_FILE_IMPORT_COUNT) {
        this.setErrorMessage(this.$t('MSG0144', { p0: MAX_FILE_IMPORT_COUNT }))
        return
      }
      this.isDisabledTabItems = true
      this.items = []
      this.files.forEach((element, index) => {
        this.importItems.push({
          file: element,
          tabTitle: '',
          index: index,
          searchPartCd: '',
          isProcessing: true,
          saveStatus: SaveStatus.WAITING,
        })
      })
    },
    onClickSearch() {
      this.isDisabledTabItems = true
      this.importItems = [
        {
          file: null,
          tabTitle: '',
          index: 1,
          searchPartCd: this.searchPartCd,
          isProcessing: true,
          saveStatus: SaveStatus.WAITING,
        },
      ]
    },
    onClickSave() {
      // 子コンポーネントの保存メソッド発火
      for (const e of this.$refs.characTable) {
        e.onClickSave()
      }
    },
    checkForDuplicateTabTitles() {
      // 重複するタブタイトルがあるかどうかを確認
      try {
        const titleCount = {}
        // importItemsを走査して各tabTitleの出現回数をカウント
        this.importItems.forEach((item) => {
          if (titleCount[item.tabTitle]) {
            titleCount[item.tabTitle] += 1
          } else {
            titleCount[item.tabTitle] = 1
          }
        })
        // 出現回数が2回以上のtabTitleを見つける
        const duplicates = Object.keys(titleCount).filter((title) => titleCount[title] > 1)
        if (duplicates.length > 0) {
          // 重複しているタブタイトルがある場合
          // エラーを投げる
          throw new Error(this.$t('MSG0030', { p0: this.$t('ELE0193') }))
        }
      } catch (error) {
        // エラー処理
        // エラーメッセージ表示
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0030', { p0: this.$t('ELE0193') })))
        // エラーなので、全て中止
        this.onClickReset()
      }
    },
    async onFinishedSave(item) {
      if (item.saveStatus == SaveStatus.SUCCESS) {
        // 取込が成功した場合、タブを閉じる
        await this.onDeleteTab(item)
      }
      if (this.importItems.length <= 0) {
        // 全てのタブが閉じた（取込成功）場合、リセット
        this.onClickReset()
        this.setSuccessMessage(this.$t('MSG0011', { p0: this.$t('ELE0091') }))
      }
    },
    onDeleteTab(item) {
      const index = this.importItems.findIndex((e) => e.index == item.index)
      this.importItems.splice(index, 1)
    },
    async setStandardValues() {
      try {
        let params = {}
        if (this.validOnly) {
          params.validOnly = true
        }

        const inspStdResponse = await API.get('/master/inspStd', params)
        inspStdResponse.forEach((element) => {
          element['text'] = `${element['inspStdCd']} : ${element['inspStdName']}`
          this.inspStd.push(element)
        })
        const qltyStdResponse = await API.get('/master/qltyStd', params)
        qltyStdResponse.forEach((element) => {
          element['text'] = `${element['qltyStdCd']} : ${element['qltyStdName']}`
          this.qltyStd.push(element)
        })
      } catch (error) {
        this.setErrorMessage(
          this.resolveErrorMessage(error, this.$t('MSG0002', { p0: `${(this.$t('ELE0388'), this.$t('ELE0392'))}` })),
        )
      }
    },
    async setParameter() {
      try {
        const param_char = await API.get(`/master/systemParameters?key=CHAR`)
        const param_pt = await API.get(`/master/systemParameter/${SystemParameterKey.PT_CD_LEN}`)
        param_char?.forEach((element) => {
          if (element.key == SystemParameterKey.CHAR_TECNO_LIMIT) {
            this.tecNoLimit = Number(element.value) > 0 ? Number(element.value) : 200
          }
          if (element.key == SystemParameterKey.CHAR_TECNO_REQ) {
            this.tecNoReq = element.value == 'TRUE'
          }
        })
        this.ptCdLen = param_pt.value
      } catch (error) {
        this.tecNoLimit = 200
        this.tecNoReq = false
        this.ptCdLen = ''
        if (error.response.status != 404) {
          this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0348') })))
        }
      }
    },
  },
  mounted() {
    this.setStandardValues()
    this.setParameter()
  },
}
</script>
